/**
 * 清掃報告フローの遷移先。
 *
 * ルート配列は順序を強制しないため、各ページが次のパスを直接指定して遷移する。
 * 「どのステップの次がどこか」はここに集約して各ページから参照する。
 *
 * 順序: checkitems → room-supply → lost-items → garbage-check
 */
export const nextPathAfterLostItem = () => "garbage-check"

export const nextPathAfterRoomSupply = () => "lost-items"

export const nextPathAfterCheckItems = () => "room-supply"
